import { h, render, Component } from 'preact';
import CommonBlock from '../commonBlock';
import Utils from '../../../utils';
import { Context } from '../../context';
import CiblerAPI from '../../ciblerApi';
import './index.scss'

export default class Notification extends CommonBlock {
  constructor(props) {
    super(props);

    this.closable = Utils.getCampaignData(this.props.notifBell, false);
    this.closed = !!(localStorage.getItem('currentClosed') || '').includes(this.props.campaignId)
      && this.closable;
    this.roundBell = Utils.getCampaignData(this.props.roundBell, false);
    this.bellBackground = Utils.getCampaignData(this.props.bellBackground, '');

    this.state = {
      content: '',
      showGift: false,
      open: !this.closed,
      contentOpen: !this.closed,
    };

    this.AssetsPath = `${Context.clientUrl}campaigns/assets/${props.campaignId}/${Context.device}`;
    this.contentWidth = this.state.open ? 0 : Utils.getCampaignData(this.props.iconWidth)
      ? Utils.getCampaignData(this.props.iconWidth)
      : 72;
  }

  componentDidMount() {
    const content = this.renderContent();

    if (content) {
      this.setState({ content });
    }

    this.contentWidth = document.getElementById('wioIconBlock').clientWidth;
  }

  getStyle = () => {
    let style = {
      transition: 'opacity 500ms linear, width 200ms linear, ' +
        'height 200ms linear, border-radius 200ms linear,' +
        'background 200ms linear',
      opacity: 1,
      backgroundSize: 'contain',
      display: 'flex',
      flexDirection: 'row',
      borderRadius: '10px',
      overflow: 'hidden',
      padding: 0,
      boxShadow: '0px 5px 10px 0px #00000080',
    };
    if (Utils.getCampaignData(this.props.shadowColor)) style.boxShadow = `0px 5px 10px 0px ${Utils.getCampaignData(this.props.shadowColor)}80`;
    if (Utils.getCampaignData(this.props.backgroundImg)) style.backgroundImage = `url('${Context.clientUrl}campaigns/assets/${this.props.campaignId}/${Context.device}${this.AssetsPath}${Utils.getCampaignData(this.props.backgroundImg)}')`;
    if (Utils.getCampaignData(this.props.height)) style.maxHeight = Utils.getCampaignData(this.props.height);
    if (Utils.getCampaignData(this.props.textColor)) style.color = Utils.getCampaignData(this.props.textColor);
    if (Context.device === 'desktop') style.minWidth = '300px';
    const styleKey = ['backgroundColor', 'fontFamily', 'width', 'top', 'left', 'bottom', 'right'];
    styleKey.forEach((key) => {
      if (Utils.getCampaignData(this.props[key])) style[key] = Utils.getCampaignData(this.props[key]);
    });

    if (!this.state.open || !this.state.contentOpen) {
      style.height = `${this.contentWidth}px`;
      style.minWidth = 'initial';
    }

    if (!this.state.open) {
      style.width = `${this.contentWidth}px`;
      if (this.roundBell) {
        style.borderRadius = `${this.contentWidth}px`;
      }
      if (this.bellBackground) {
        style.backgroundColor = this.bellBackground;
      }
    }

    return style;
  };

  handleAcceptClick = () => {
    if (!this.state.showGift) {
      window.WIO.track('discoverBlock', this.props.campaignId, Context.sessionId);
      CiblerAPI.discoverGift(Context[this.props.campaignId], this.completeGift(this.props.content?.value));
      return;
    }

    if (this.buttonType.includes('exit')) {
      window.location.href = this.exitUrl;
    }
    if (this.buttonType.includes('newtab')) {
      window.open(this.exitUrl, "_blank");
    }
    if (this.buttonType.includes('close')) {
      this.closable ? this.toggleOpen() : this.props.refuseBlock();
    }

    if (this.buttonType.includes('copy')) this.props.acceptBlock();
  };

  toggleOpen = () => {
    if (!this.closable) return;

    if (this.state.open) {
      localStorage.setItem('currentClosed',
        `${localStorage.getItem('currentClosed') || ''}|${this.props.campaignId}`);
      this.setState({contentOpen: false, open: false});
      return;
    }

    localStorage.setItem('currentClosed',
      localStorage.getItem('currentClosed').replace(`|${this.props.campaignId}`, ''));
    this.setState({open: true});
    setTimeout(() => this.setState({contentOpen: true}), 200);
  }

  render() {
    const banClass = Utils.getCampaignData(this.props.emplacement) ? `Wio${Utils.getCampaignData(this.props.emplacement)}` : '';
    const contentClose = !this.state.contentOpen;
    const close = !this.state.open;

    return (
      <div>
        <style>{`
          #wio_notifv3 {
            width: ${Utils.getCampaignData(this.props.width, '400px')};
            background-color: ${Utils.getCampaignData(this.props.backgroundColor, '#fff')};
            left: ${Utils.getCampaignData(this.props.left, '0')};
            bottom: ${Utils.getCampaignData(this.props.bottom, '50px')};
          }
          #wioBlockAccept {
            background: ${Utils.getCampaignData(this.props.acceptButtonColor, '#253645')};
            color: ${Utils.getCampaignData(this.props.acceptButtonFontColor, '#fff')};
          }
          #wioBlockExit {
            color: ${Utils.getCampaignData(this.props.exitButtonFontColor, '#000')};
            text-decoration: underline;
          }
      `}</style>
        <div
          id="wio_notifv3"
          className={`WioFloat WioBanner ${banClass} ${close ? 'close' : ''} ${contentClose ? 'contentClose' : ''}`}
        >
          <div
            id="wioIconBlock"
            onClick={this.toggleOpen}
          >
            <img
              alt="icon"
              src={`${this.AssetsPath}${Utils.getCampaignData(this.props.iconUrl)}`}
            />
          </div>
            <div id="wioContent">
              <div
                dangerouslySetInnerHTML={{ __html: this.state.content }}
              />
            </div>
            <div className="buttonBlock">
              <button
                id="wioBlockAccept"
                onClick={this.handleAcceptClick}
              >
                {this.state.showGift
                  ? Utils.getCampaignData(this.props.useText, 'Utiliser')
                  : Utils.getCampaignData(this.props.acceptText, 'Voir')}
              </button>
              <button
                id="wioBlockExit"
                onClick={this.closable ? this.toggleOpen : this.props.refuseBlock}
              >
                {this.state.showGift
                  ? Utils.getCampaignData(this.props.closeText, 'Fermer')
                  : Utils.getCampaignData(this.props.refuseText, 'Fermer')}
              </button>
            </div>
        </div>
      </div>
    );
  }
}
